import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

export const AreaC_Van_Left: React.FC<AreaSVGProps> = ({
  fill = '#FE6728',
  stroke = '#FE6728',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="197"
      height="302"
      viewBox="0 0 197 302"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_c_van_left"
          x="0"
          y="0"
          width="197"
          height="302"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
      <g filter="url(#filter_area_c_van_left)">
        <path
          d="M30.4912 1.00293C47.6601 0.947939 69.3943 1.66731 91.8994 3.11035C114.406 4.55349 137.612 6.71611 157.732 9.53613C176.044 12.1026 182.803 13.035 192.423 16.3711L192.74 24.6074V24.6084C192.74 24.6108 192.741 24.6269 192.741 24.6387L193.095 32.6719C193.859 50.3094 194.53 67.7262 194.658 73.9023L194.677 74.9844V74.9863C195.262 123.33 196.75 192.363 193.176 257.351L193.002 260.433L191.294 285.684C167.698 294.311 142.946 299.693 109.859 300.047C77.7169 300.391 46.4991 298.05 26.1055 295.619L24.6943 261.574C29.0829 259.504 35.551 255.484 41.5547 249.211C49.8083 240.587 57.3476 227.536 57.3477 209.316L57.3418 208.401C57.0794 189.274 48.5931 175.082 36.7549 165.622C26.2568 157.234 13.2095 152.615 1 151.274V2.5C2.90381 2.19167 5.48336 1.90074 8.76172 1.66504C14.5092 1.25184 21.9011 1.03045 30.4912 1.00293Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
